import { render, staticRenderFns } from "./AuditLogButton.vue?vue&type=template&id=f9b7223c&scoped=true"
import script from "./AuditLogButton.vue?vue&type=script&lang=js"
export * from "./AuditLogButton.vue?vue&type=script&lang=js"
import style0 from "./AuditLogButton.vue?vue&type=style&index=0&id=f9b7223c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b7223c",
  null
  
)

export default component.exports